__turbopack_context__.v({
  "asset": "Sqd39W_asset",
  "assetColumn": "Sqd39W_assetColumn",
  "assetImg": "Sqd39W_assetImg",
  "assetLabel": "Sqd39W_assetLabel",
  "assetSeparator": "Sqd39W_assetSeparator",
  "hero": "Sqd39W_hero",
  "subtitle": "Sqd39W_subtitle",
  "title": "Sqd39W_title",
  "titleInnerText": "Sqd39W_titleInnerText",
  "titleWithIcon": "Sqd39W_titleWithIcon",
  "wrapper": "Sqd39W_wrapper",
});
